module.exports = __webpack_public_path__ + "static/media/bbps_report.9da9e754.svg";